import { defineStore } from "pinia";
import { ref } from "vue";
import { Material } from "../../../types/Views/MaterialDatabase/Material";
import { SpeckleMaterial } from "../../../types/Views/MappingWizard/SpeckleMaterial";

export const inspectStore = defineStore("inspectStore", () => {
  const inspections = ref<(Material | SpeckleMaterial)[]>([]);

  const getInspections = () => inspections.value;

  const addInspection = (value: Material | SpeckleMaterial) => {
    if (inspections.value.find((inspection) => inspection.id === value.id)) return;
    inspections.value.push(value);
  };

  const clearInspections = () => {
    inspections.value = [];
  };

  const sliceInspections = (index: number) => {
    inspections.value = inspections.value.slice(0, index);
  };

  return {
    getInspections,
    addInspection,
    clearInspections,
    sliceInspections,
  };
});
